import {
    IDirective
} from "angular";


export function settIframeHeightVedLastingForInjisering() {
    return [settIframeHeightVedLasting];
}

/**
 * Setter høyde på iframe like høyde på innhold når load event er trigget.
 *
 * Bruk: <iframe src="https://www.vg.no" sett-iframe-height-ved-lasting></iframe>
 * Eller sett src i iframe i ts: iframe.attr('src', this.epostUrl);
 */
export function settIframeHeightVedLasting(): IDirective {

    return {

        restrict: 'A',

        link: function (scope, element, attrs) {
            element.on('load', function () {
                const iframe = element[0];

                if (!(iframe instanceof HTMLIFrameElement)) {
                    throw new Error(`Expected e to be an HTMLIFrameElement, was ${iframe && iframe.constructor && iframe.constructor.name || iframe}`);
                }

                const iFrameHeight = iframe.contentWindow.document.body.scrollHeight + 'px';
                element.css('height', iFrameHeight);
            })
        }
    }
}
